import PropTypes from 'prop-types';
import React from 'react';
import './PrintLayout.scss';

class Print extends React.PureComponent {
  render() {
    return <div className="cp-print">{this.props.children}</div>;
  }
}

Print.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export default Print;
